import React,{useState,createContext} from 'react';

export const UserContext = createContext();
export const UserProvider = props => {
	const [user,setUser] = useState({});
	const [auth, setAuth] = useState(false);
	const [configs, setConfigs] = useState({})
	return (
		<UserContext.Provider value={{user,setUser,auth,setAuth,configs,setConfigs}}>
			{props.children}
		</UserContext.Provider>
	)
}
